module.exports = __webpack_public_path__ + "img/logo_mini.0302378b.png";